import { render, staticRenderFns } from "./command_palette_items.vue?vue&type=template&id=84971572"
import script from "./command_palette_items.vue?vue&type=script&lang=js"
export * from "./command_palette_items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports